export default {
	roles: [],
	permissions: [],
	validation: {
		name: null,
		type: null,
		center_id: null,
		permissions: null,
	},
}
